export default "__VITE_ASSET__BxnJ2U5g__"